import {escapeRegExp} from "lodash-es";
import {useMemo} from "react";

const EXAMPLE_DOMAINS = ["example.net", "example.org", "example.edu", "example"];

const COMMON_PERSONAL_EMAIL_DOMAINS = [
  "aol.com",
  "btinternet.com",
  "comcast.net",
  "free.fr",
  "gmail.com",
  "gmx.de",
  "googlemail.com",
  "hotmail.co.uk",
  "hotmail.com",
  "hotmail.fr",
  "icloud.com",
  "live.com",
  "mail.com",
  "me.com",
  "msn.com",
  "orange.fr",
  "outlook.com",
  "proton.me",
  "protonmail.com",
  "wanadoo.fr",
  "yahoo.co.in",
  "yahoo.co.uk",
  "yahoo.com",
  "yahoo.fr",
  "yandex.ru",
  "ymail.com",
  "zoho.com",
  "zoho.eu",
];

const BANNED_DOMAINS_REGEX = new RegExp(
  `@(${[...COMMON_PERSONAL_EMAIL_DOMAINS, ...EXAMPLE_DOMAINS]
    .flatMap(domain => {
      const escapedDomain = escapeRegExp(domain);
      return [escapedDomain, `${escapedDomain}\\.`];
    })
    .join("|")})$`,
);

export const useBannedEmailValidation = (email: string) => useMemo(() => BANNED_DOMAINS_REGEX.test(email), [email]);
